/* @license
 * Copyright 2022 Lowe's Companies, Inc. All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

import React, { ReactElement } from "react";
import styled from "styled-components/macro";
//import config from "../config/config";
import pjson from "../../package.json";

const VersionDiv = styled.div`
	position: absolute;
	background: #7d8492;
	border-radius: 57px;
	padding: 2px 4px;
	right: 3px;
	bottom: 6px;
	font-size: 10px;
`;

const VersionText = styled.span`
	color: #fff;
`;

function VersionDisplay(): ReactElement {
	const envName = process.env.REACT_APP_ENV === "production" ? "prod" : "dev";
	const build = process.env.REACT_APP_BUILD ?? "local";
	const version = `${pjson.version}-${envName}-${build.slice(0, 7)}`;

	return (
		<VersionDiv className="noselect">
			<VersionText>
				<span>v{version}</span>
			</VersionText>
		</VersionDiv>
	);
}

export default VersionDisplay;
